import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ListTemplateComponent } from "./list-template.component";
import { PaginationARModule } from "../pagination/pagination-ar.module";

@NgModule({
  imports: [CommonModule, PaginationARModule],
  declarations: [ListTemplateComponent],
  exports: [ListTemplateComponent]
})
export class ListTemplateModule {}
